import { Box, Typography } from '@mui/material';

export const BundleComboHeader = () => (
	<Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
		<Typography
			sx={{
				color: 'white',
				backgroundColor: 'primary.main',
				fontSize: '14px',
				fontWeight: 700,
				padding: '4px 12px',
				borderRadius: '20px',
			}}
		>
			{'COMBO'}
		</Typography>
		<Typography
			sx={{
				fontSize: { xs: '14px', md: '15px' },
				fontWeight: 'bold',
				color: '#2C2C2C',
				textTransform: 'uppercase',
			}}
		>
			{'Productos que incluye:'}
		</Typography>
	</Box>
);
